import client from "../httpClient";
import {useContext} from "react";
import { UIStoreContext } from "../../context";


const actionsService = {

    CalibrateSystem: () => {
        const uiStore = useContext(UIStoreContext);
        return client.Post(
            "calibrateSystem",
            ["calibrateSystem"],
            {enabled: uiStore.getSelectedSystem() !== ""},
            {csrf_token: uiStore.getCsrfToken()}
        );
    },
    UpdateSystem: () => {
        const uiStore = useContext(UIStoreContext);
        return client.Post(
            "updateAction",
            ["updateAction"],
            {enabled: uiStore.getSelectedSystem() !== ""},
            {csrf_token: uiStore.getCsrfToken()}
        );
    },
};


export default actionsService;